import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import deTranslation from './locales/de/translation.json'
import enTranslation from './locales/en/translation.json'

const resources = {
  en: {
    translation: enTranslation,
  },
  de: {
    translation: deTranslation,
  },
} as const

export const SUPPORTED_LANGUAGES = Object.keys(resources) as (keyof typeof resources)[]

export type SupportedLanguages = keyof typeof resources

/*
    * Utility type to recursively extract nested keys from an object
    * and concatenate them with dot notation.
    * Example:
    * Given the object:
    * {
    *   a: {
    *     b: {
    *       c: "value"
    *     },
    *     d: "value"
    *   },
    *   e: "value"
    * }
    * The resulting type will be:
    * "a.b.c" | "a.d" | "e"
 */
type NestedKeyOf<ObjectType extends Record<string, any>, Prefix extends string = ''> = {
  [Key in keyof ObjectType & string]: ObjectType[Key] extends string
    ? Prefix extends ''
      ? Key
      : `${Prefix}.${Key}`
    : ObjectType[Key] extends Record<string, any>
    ? NestedKeyOf<ObjectType[Key], Prefix extends '' ? Key : `${Prefix}.${Key}`>
    : never
}[keyof ObjectType & string]

// Extract all possible translation keys from the resources
export type TranslationKey = NestedKeyOf<typeof resources.en.translation>

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    debug: false,
  })

export default i18n
